
    import { Options, Vue } from "vue-class-component";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import FaltaService from "@/service/v10/sigap/FaltaService";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import Multiselect from "@vueform/multiselect";

    @Options({
        name: "FaltaIndex",
        components: { CardRh, KDataTable, Multiselect },
    })
    export default class FaltaIndex extends Vue {
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public status_id: any = null;
        public matriculaId: any = null;
        public status: any = null;
        public dataMin = '';
        public dataMax = '';

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }
 

        get status_select() {
            if (this.status) {
                return this.status.map((item) => {
                    return { value: item.id, label: item.nome };
                });
            }
            return [];
        }

        public getStatus() {
            this.processando = true;
            this.service.getStatus()
                .then(response => {
                    this.status = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }

        created() {
            this.matriculaId = this.$route.params.id;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new FaltaService();
            this.getStatus();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        DataMin: this.dataMin,
                        DataMax: this.dataMax,
                        status: this.status_id,
                        matriculaId: this.matriculaId,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: 'data', name: 'data' },
                { data: 'disciplina', name: 'disciplina' },
                { data: 'aula', name: 'aula', class: 'desktop' },
                { data: 'faltaMotivo', name: 'faltaMotivo', class: 'desktop' },
                { data: 'faltaTipo', name: 'faltaTipo', class: 'desktop' },
                { data: 'status', name: 'status', searchable: false, class: 'text-center desktop' },
            ];

            this.config.columnDefs = [
                {
                    targets: 0,
                    render: (row, type, val) => {
                        return SiteUtils.formatData(val.aula.data);
                    }
                },
                {
                    targets: 1,
                    render: (row) => {
                        return row != null ? row.descricao : '';
                    }
                },
                {
                    targets: 2,
                    render: (row) => {
                        return row != null ? row.numero : '';
                    }
                },
                {
                    targets: 3,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 4,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 5,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
            ];
        }
    }
